import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { MeasureTypeStore } from '../stores/measure-type.store';

@Injectable({
  providedIn: 'root',
})
export class MeasureTypesResolver implements Resolve<void> {
  private readonly measureTypesStore = inject(MeasureTypeStore);

  async resolve(): Promise<void> {
    await this.measureTypesStore.loadAll();

    return Promise.resolve();
  }
}
